module.exports = __webpack_public_path__ + "img/kuaishou-code.3cfb12e0.png";